import PropTypes from 'prop-types';
import { LayoutGrid, List } from 'lucide-react';
import { Stack } from '@/components/ui/index.js';
import styles from './ViewToggle.module.css';

/**
 * ViewToggle - Grid/List view toggle button group
 * Allows users to switch between grid and list event layouts
 */
export function ViewToggle({ viewMode, onViewChange }) {
  return (
    <Stack direction="row" gap={0} className={styles.toggleContainer}>
      <button
        type="button"
        className={`${styles.toggleButton} ${viewMode === 'grid' ? styles.active : ''}`}
        onClick={() => onViewChange('grid')}
        aria-label="Grid view"
        aria-pressed={viewMode === 'grid'}
      >
        <LayoutGrid size={18} />
      </button>
      <button
        type="button"
        className={`${styles.toggleButton} ${viewMode === 'list' ? styles.active : ''}`}
        onClick={() => onViewChange('list')}
        aria-label="List view"
        aria-pressed={viewMode === 'list'}
      >
        <List size={18} />
      </button>
    </Stack>
  );
}

ViewToggle.propTypes = {
  viewMode: PropTypes.oneOf(['grid', 'list']).isRequired,
  onViewChange: PropTypes.func.isRequired,
};

export default ViewToggle;
